import { render, staticRenderFns } from "./QsHeader.vue?vue&type=template&id=1f8757a9&scoped=true&"
import script from "./QsHeader.vue?vue&type=script&lang=js&"
export * from "./QsHeader.vue?vue&type=script&lang=js&"
import style0 from "./QsHeader.vue?vue&type=style&index=0&id=1f8757a9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8757a9",
  null
  
)

export default component.exports